import React from "react";
import "./CodeConduct.scss";
import codeImg from "../../../assets/About/code-of-conduct.jpg";
import codeConductBg from "../../../assets/About/code-conduct-bg.png";
import useAboutUs from "../../../hooks/useAboutUs";

const CodeConduct = () => {
  const [aboutUs, setAboutUs] = useAboutUs();

  let codeConductData = aboutUs.filter(
    (code) => code.DescType === "Code of Conduct"
  );

  return (
    <>
      <div className="code_conduct">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${codeConductBg})` }}
            data-aos="zoom-in"
          ></div>
          <div className="heading_box">Code Of Conduct</div>

          <div className="container">
            <div className="code_conduct_content">
              <div className="code_content_img text-center">
                <img src={codeImg} className="img-fluid" alt="" />
                {/* <img src={codeImg3} className="img-fluid" alt="" /> */}
              </div>

              <div
                className="mt-5"
                data-aos="fade-down"
                data-aos-anchor-placement="bottom-bottom"
              >
                {codeConductData.map((ccd, index) => (
                  <div key={index} className="text_content">
                    <h4>{ccd.Title}</h4>
                    <ul>
                      <li>{ccd.Description}</li>
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CodeConduct;
<div></div>;
